import { CategoriesTableType } from '../../../types/Admin/CategoriesTopicsTypes';

export function getTopicsByCategoryId(sectionsArr: CategoriesTableType[], sectionId: number) {
  // Важно: одна и та же категория может встретиться в `sectionsArr` несколько раз
  // (например, если данные приходят "разрезанными" по очередям/филиалам).
  // Для корректной работы модалки объединяем список услуг по id.
  const sections = sectionsArr?.filter((s: CategoriesTableType) => s.id === sectionId) ?? [];
  if (sections.length === 0) return [];

  const map = new Map<number, { id: number; nameRu: string }>();
  for (const section of sections) {
    for (const topic of section.topics ?? []) {
      if (topic?.id == null) continue;
      if (!map.has(topic.id)) {
        map.set(topic.id, { id: topic.id, nameRu: topic.nameRu });
      }
    }
  }

  return Array.from(map.values());
}
